import React from "react";
import clsx from "clsx";
import { useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Style from "../styles/js/Styles.js";
import Axios from "axios";

// ICONS
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import HistoryIcon from "@material-ui/icons/History";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import ShoppingCartOutlinedIcon from "@material-ui/icons/ShoppingCartOutlined";
import SupervisedUserCircleIcon from "@material-ui/icons/SupervisedUserCircle";
import LocalPharmacyIcon from "@material-ui/icons/LocalPharmacy";
import AddLocationIcon from "@material-ui/icons/AddLocation";
import AddAlertIcon from "@material-ui/icons/AddAlert";
import BuildIcon from "@material-ui/icons/Build";
import AyacuchoIcon from "../assets/images/ayacucho/lg.png";
import AssignmentIndIcon from "@material-ui/icons/AssignmentInd";
import EventNoteIcon from "@material-ui/icons/EventNote";
import EqualizerIcon from "@material-ui/icons/Equalizer";
import DateRangeIcon from "@material-ui/icons/DateRange";
import ExploreIcon from "@material-ui/icons/Explore";
import GroupIcon from "@material-ui/icons/Group";
import PersonPinCircleIcon from "@material-ui/icons/PersonPinCircle";

// VIEWS
import Business from "./business/Business.js";
import Emergency from "./emergency/Emergency.js";
import Quarentine from "./quarentine/Quarentine.js";
import News from "./notifications/Notifications.js";
import NewsHistory from "./newsHistory/newsHistory.js";
import Pharmacy from "./pharmacy/pharmacy.js";
import Users from "./users/Users.js";
import ABMCategories from "./categories/ABMCategories";
import Reports from "./reports/Reports.js";
import Reservation from "./reservation/Reservation.js";
import Dashboard from "./dashboard/Dashboard.js";
import ABMEvents from "./events/ABMEvents.js";
import Visits from "./visits/Visits.js";
import Contact from "./contacts/Contacts";

// AUTH
import auth from "./login/Auth.js";
import { Access } from "../auth/Access.js";
import * as Constants from "../consts/Constants.js";
import {
  Switch,
  Route,
  Link,
  BrowserRouter,
  HashRouter,
} from "react-router-dom";
import Contacts from "./contacts/Contacts";

export default function Index({ history }) {
  const style = Style();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleLogOut = () => {
    //TODO deslogar con auth.
    //auth.logout();
    localStorage.removeItem("auth");
    Axios.defaults.headers.common["Authorization"] = "";
    history.push("/login");
  };

  let refresed = false;
  const loadToken = () => {
    Axios.interceptors.response.use(
      (response) => {
        return response;
      },
      function (error) {
        const originalRequest = error.config;
        if (
          (error.response.status === 401 || error.response.status === 403) &&
          !refresed
        ) {
          console.log("primera reconexion");
          originalRequest._retry = true;
          refresed = true;

          var oldAuth = JSON.parse(localStorage.getItem("auth"));

          return Axios.post(
            Constants.FINAL_URL_AUTH,
            JSON.stringify(oldAuth.credentials),
            {
              headers: { "Content-Type": "application/json" },
            }
          ).then((response) => {
            if (response.status === 200) {
              refresed = false;
              Axios.defaults.headers.common["Authorization"] =
                "Bearer " + response.data.token;
              auth.login(
                oldAuth.credentials,
                response.data.token,
                response.data.additionalRoles,
                response.data.userId,
                response.data.role
              );
              localStorage.setItem("auth", JSON.stringify(auth));
              originalRequest.headers.Authorization =
                "Bearer " + response.data.token;
              return Axios(originalRequest);
            }
          });
        } else if (
          error.response.status === 401 ||
          error.response.status === 403
        ) {
          console.log("reconecto mal");

          refresed = false;
          handleLogOut();
        }
      }
    );
    let user = JSON.parse(localStorage.getItem("auth"));
    if (user != null && user.authenticated)
      Axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
  };

  loadToken();

  let access = new Access();

  return (
    <div className={style.root}>
      <AppBar
        position="fixed"
        className={clsx(style.appBar, {
          [style.appBarShift]: open,
        })}
      >
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(style.menuButton, {
              [style.hide]: open,
            })}
          >
            <MenuIcon />
          </IconButton>
          <img
            src={AyacuchoIcon}
            alt="Municipalidad de Ayacucho"
            className={style.image}
          />
          <Typography variant="h6" style={{ color: "#9d9d9d" }} noWrap>
            APS - Ayacucho Plataforma de Servicios
          </Typography>
        </Toolbar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(style.drawer, {
          [style.drawerOpen]: open,
          [style.drawerClose]: !open,
        })}
        classes={{
          paper: clsx({
            [style.drawerOpen]: open,
            [style.drawerClose]: !open,
          }),
        }}
      >
        <div className={style.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "rtl" ? (
              <ChevronRightIcon />
            ) : (
              <ChevronLeftIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>
          {access.canDashboardAcces() ? (
            <ListItem button component={Link} to={"/dashboard"}>
              <ListItemIcon>
                <EqualizerIcon />
              </ListItemIcon>
              <ListItemText primary="Dashboard" />
            </ListItem>
          ) : null}
          {access.canVisitMapsAcces() ? (
            <ListItem button component={Link} to={"/visits"}>
              <ListItemIcon>
                <ExploreIcon />
              </ListItemIcon>
              <ListItemText primary="Mapa de estadias" />
            </ListItem>
          ) : null}
          {access.canContactAcces() ? (
            <ListItem button component={Link} to={"/contacts"}>
              <ListItemIcon>
                <PersonPinCircleIcon />
              </ListItemIcon>
              <ListItemText primary="Contactos" />
            </ListItem>
          ) : null}
          {access.canNewsAccess() ? (
            <ListItem button component={Link} to={"/news"}>
              <ListItemIcon>
                <AddAlertIcon />
              </ListItemIcon>
              <ListItemText primary="Enviar notificaciones" />
            </ListItem>
          ) : null}
          {access.canNewsHistoryAccess() ? (
            <ListItem button component={Link} to={"/newsHistory"}>
              <ListItemIcon>
                <HistoryIcon />
              </ListItemIcon>
              <ListItemText primary="Historial de noticias" />
            </ListItem>
          ) : null}
          {access.canUserAccess() ? (
            <ListItem button component={Link} to={"/pharmacy"}>
              <ListItemIcon>
                <LocalPharmacyIcon />
              </ListItemIcon>
              <ListItemText primary="Farmacias de turno" />
            </ListItem>
          ) : null}
          {access.canCategoriesAcces() ? (
            <ListItem button component={Link} to={"/categories"}>
              <ListItemIcon>
                <BuildIcon />
              </ListItemIcon>
              <ListItemText primary="Gestión de categorias" />
            </ListItem>
          ) : null}
          {access.canQuarentineAccess() ? (
            <ListItem button component={Link} to={"/covid"}>
              <ListItemIcon>
                <AddLocationIcon />
              </ListItemIcon>
              <ListItemText primary="Personas en aislamiento" />
            </ListItem>
          ) : null}
          {access.canEmergencyAccess() ? (
            <ListItem button component={Link} to={"/emergency"}>
              <ListItemIcon>
                <ReportProblemIcon />
              </ListItemIcon>
              <ListItemText primary="Alertas de emergencia" />
            </ListItem>
          ) : null}
          {access.canBusinessAccess() ? (
            <ListItem button component={Link} to={"/business"}>
              <ListItemIcon>
                <ShoppingCartOutlinedIcon />
              </ListItemIcon>
              <ListItemText primary="Comercios" />
            </ListItem>
          ) : null}
          {access.canUserAccess() ? (
            <ListItem button component={Link} to={"/users"}>
              <ListItemIcon>
                <SupervisedUserCircleIcon />
              </ListItemIcon>
              <ListItemText primary="Usuarios" />
            </ListItem>
          ) : null}
          {access.canReportsAcces() ? (
            <ListItem button component={Link} to={"/reports"}>
              <ListItemIcon>
                <AssignmentIndIcon />
              </ListItemIcon>
              <ListItemText primary="Reportes" />
            </ListItem>
          ) : null}
          {access.canReservationAcces() ? (
            <ListItem button component={Link} to={"/reservation"}>
              <ListItemIcon>
                <EventNoteIcon />
              </ListItemIcon>
              <ListItemText primary="Reservaciones" />
            </ListItem>
          ) : null}
          <ListItem button onClick={handleLogOut}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText primary="Log out" />
          </ListItem>
        </List>
      </Drawer>
      <main className={style.content}>
        <div className={style.toolbar} />
        <Switch>
          <Route path="/news">
            <News />
          </Route>
          <Route path="/newsHistory">
            <NewsHistory />
          </Route>
          <Route path="/categories">
            <ABMCategories />
          </Route>
          <Route path="/covid">
            <Quarentine />
          </Route>
          <Route path="/emergency">
            <Emergency />
          </Route>
          <Route path="/business">
            <Business />
          </Route>
          <Route path="/users">
            <Users />
          </Route>
          <Route path="/pharmacy">
            <Pharmacy />
          </Route>
          <Route path="/reports">
            <Reports />
          </Route>
          <Route path="/reservation">
            <Reservation />
          </Route>
          <Route path="/dashboard">
            <Dashboard />
          </Route>
          <Route path="/visits">
            <Visits />
          </Route>
          <Route path="/contacts">
            <Contacts />
          </Route>
        </Switch>
      </main>
    </div>
  );
}
